<template>
  <div v-loading="loading">
    <el-input
      v-model="config.goodsName"
      clearable=""
      style="margin-bottom:10px;"
      placeholder="请输入商品名称">
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="fetchList"></el-button>
    </el-input>
    <el-table
      :data="items"
      border=""
      @row-click="selectitem">
      <el-table-column
        prop="goodsName"
        label="商品名称"
        min-width="240">
      </el-table-column>
      <el-table-column
        label="价格"
        width="120"
        :resizable="false"
        prop="productNumber">
        <template slot-scope="{row}">
          ￥{{ row.seckillPrice }} / <span style="text-decoration: line-through;color:red">￥{{ row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :resizable="false"
        label="商品描述"
        min-width="180"
        prop="goodsDesc"></el-table-column>
    </el-table>
    <!-- <el-tag
      v-for="item in items"
      :key="item.seckillGoodsId"
      size="medium"
      type="success"
      effect="plain"
      @click="selectitem(item)">
      {{ item.goodsName }}
    </el-tag> -->
  </div>
</template>

<script>
export default {
  name: 'IntegralTask',
  props: {
    linkType: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      config: { goodsName: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    selectitem(item) {
      this.$emit('select', {
        linkType: this.linkType,
        link: item.seckillGoodsId,
        title: item.goodsName,
        contentType: item.goodsId
      })
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('discount/getongoingseckillgoodslist', {
        payload: {
          pageNum: 1,
          pageSize: 10000,
          status: 1,
          ...this.config
        },
        success: res => {
          this.loading = false
          this.items = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style>

</style>
